import { Redirect } from "wouter";
import { useAuth } from "@/contexts/AuthContext";

interface TeamAdminRouteProps {
  children: React.ReactNode;
}

// Gate for routes that require team_admin or system_admin. Mirrors the
// backend `role.Require("team_admin")` middleware, where sys_admin also
// passes.
export function TeamAdminRoute({ children }: TeamAdminRouteProps) {
  const { user, isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex h-screen w-full items-center justify-center bg-[#0a0e1a]">
        <div className="flex flex-col items-center gap-4">
          <div className="h-8 w-8 animate-spin rounded-full border-2 border-blue-500 border-t-transparent" />
          <p className="text-sm text-gray-400">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Redirect to="/login" />;
  }

  if (user?.must_change_password) {
    return <Redirect to="/change-password" />;
  }

  if (user?.role !== "team_admin" && !user?.is_system_admin) {
    return <Redirect to="/console/dashboard" />;
  }

  return <>{children}</>;
}
